import BaseComponent from "../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import Pager from "./pagination/Pager";
import PropTypes from "prop-types";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import React, {createRef} from 'react';
import Listener from "../../../../lib/model/system/Listener";
import LoadingButton from '@mui/lab/LoadingButton';

import Privilege from "../../../../lib/model/types/Privilege";
import DataType from "../../../../lib/model/types/DataType";
import FieldName from "../../../../lib/model/query/FieldName";
import GF from "../../../../lib/utils/GF";
import FilterBuilder from "../extendedFilter/FilterBuilder";
import shortid from "shortid";
import BooleanPredicate from "../../../../lib/model/query/BooleanPredicate";
import FieldPredicate from "../../../../lib/model/query/FieldPredicate";
import Operator from "../../../../lib/model/query/Operator";
import Query from "../../../../lib/model/query/Query";
import CleanPredicates from "./CleanPredicates";
import Records from "../../../../lib/model/service/entity/dto/Records";
import CM from "../../../model/system/CM";
import Upload from "./upload/Upload";
import TableFieldGenerator from "./fields/TableFieldGenerator";
import FilterManager from "../../../../lib/components/filter/FilterManager";
import DialogBase from "../../../../lib/components/dialogs/DialogBase";
import {toast} from "react-toastify";
import InputFieldGenerator from "./fields/InputFieldGenerator";
import SimpleFilterBuilder from "./filter/SimpleFilterBuilder";
import CampaignService from "../../../model/service/campaign/CampaignService";
import T from "../../../model/system/text_translations/Translator";
import Resource from "../../../../lib/model/resource/Resource";
import {DataGrid, GridRowEditStopReasons, GridToolbar} from "@mui/x-data-grid";
import Grid from "@mui/material/Grid2";
import InputDateTimePicker from "../inputFields/InputDateTimePicker";
import {deDE} from "@mui/x-data-grid/locales";
import Button from "../buttons/Button";
import EntityExport from "./export/EntityExport";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import CrudAction from "./CrudAction";
import InputUpload from "../inputFields/InputUpload";
import InputDownload from "../inputFields/InputDownload";
import BaseTab from "../tabbar/BaseTab";
import FilterListDialog from "../filterManager/FilterListDialog";
import SysLastValueRead from "../../../../lib/model/service/system/dto/SysLastValueRead";
import SysLastValueWrite from "../../../../lib/model/service/system/dto/SysLastValueWrite";
import SystemService from "../../../../lib/model/service/system/SystemService";
import SortField from "../../../../lib/model/query/SortField";
import SimpleSearchHeaderCell from "./SimpleSearchHeaderCell";
import SimpleFilterFieldGenerator from "./fields/SimpleFilterFieldGenerator";

class Entity extends BaseComponent {

  constructor(props) {
    super(props);
    this.initDatasourceListenerProperties();
    this.initButtonGroupListenerProperties();
    this.loadVisibilityChange();
    this.state = {
      rows: [],
      columns: [],
      extendedFilter: null,
      filterManagerDialog: null,
      dialogTitle: null,
      confirmationDialogConfirmAction: null,
      dialogContent: null,
      confirmationDialogOpen: false,
      recordDialogOpen: false,
      filterManagerDialogOpen: false,
      saveFilterDialogOpen: false,
      isLoading: false,
      crudAction: null,
      totalRows: 0,
      dataGridsPageSize: 10,
      dataGridsActualPage: 1,
      isFilterListDialogOpen: false,
      filterListRows: [],
      filterListData: [],
      visibilityModel: "",
      sortModel: [],
      density: 'standard',
      validationErrorFields: new Set(),
      dialogKey: 'init'
    };
    this.mainPanel = CM.get().getPanel();
    this.config = GF.getValue(this.props.config, null);
    this.numOfColumns = -1;
    this.hasRecordsInGrid = false;
    this.simpleSearchIsActive = false;
    this.simpleSearchValues = {};
    this.tableRef = createRef();
    this.filterBuilderRef = createRef();
    this.entityContainerRef = createRef();
    this.simpleFilterFieldList = [];
    this.detailFieldList = [];
    this.tableFieldGenerator = GF.getValue(this.props.tableFieldGenerator, new TableFieldGenerator());
    this.editFieldGenerator = GF.getValue(this.props.editFieldGenerator, new InputFieldGenerator());
    this.editFieldGenerator.onErrorChange = (id, hasError) => this.onFieldErrorChange(id, hasError);
    this.simpleFilterBuilder = new SimpleFilterBuilder(this);
    // Generiert je Datentyp das passende Suchfeld (Dropdown, Checkbox, DatePicker, Text, ...)
    // für die Spaltenkopf-Suche (vereinfachter Filter, siehe doOpenSimpleSearch()).
    this.simpleSearchFieldGenerator = new SimpleFilterFieldGenerator(
      (e, id, value) => this.handleSimpleSearchChange(id, value),
      'outline',
      (id, value) => this.handleSimpleSearchChange(id, value));
    this.filterManagerRef = createRef();
    this.simpleFilterTimerActive = 0;
    this.filterManagerDialogRef = createRef();
    this.uploadRef = createRef();
  }

  /**
   * Wird von Eingabefeldern über onErrorChange aufgerufen wenn sich ihr Validierungsstatus ändert.
   * Pflegt das validationErrorFields-Set und aktualisiert den State (→ Speichern-Button).
   */
  onFieldErrorChange = (id, hasError) => {
    this.setState(prevState => {
      const errors = new Set(prevState.validationErrorFields);
      if (hasError) {
        errors.add(id);
      } else {
        errors.delete(id);
      }
      return {validationErrorFields: errors};
    });
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.dataSource) {
      this.dataSource = this.props.dataSource;
      this.initConfig();
      this.initTable();
      this.doAddDatasourceListeners();
      if (this.props.autoload === undefined || this.props.autoload === true) {
        this.dataSource.read();
      }
    } else {
      this.state.rows = GF.getValue(this.props.children, []);
    }
    this.doAddButtonGroupListeners();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.doRemoveDatasourceListeners();
    this.doRemoveButtonGroupListeners();
  }


  doAddDatasourceListeners() {
    if (GF.checkNotNull(this.dataSource)) {
      this.dataSource.dataSourceEvents.addOnReadDoneListener(this.addOnReadDoneListener);
      this.dataSource.dataSourceEvents.addOnRowChangeListener(this.addOnRowChangeListener);
      this.dataSource.dataSourceEvents.addOnUpdateDoneListener(this.addOnUpdateDoneListener);
      this.dataSource.dataSourceEvents.addOnCreateDoneListener(this.addOnCreateDoneListener);
      this.dataSource.dataSourceEvents.addOnDeleteDoneListener(this.addOnDeleteDoneListener);
      this.dataSource.dataSourceEvents.addOnDuplicateDoneListener(this.addOnDuplicateDoneListener)
      this.dataSource.dataSourceEvents.addOnErrorListener(this.addOnErrorListener);
    }
  }

  doRemoveDatasourceListeners() {
    if (GF.checkNotNull(this.dataSource)) {
      this.dataSource.dataSourceEvents.removeOnReadDoneListener(this.addOnReadDoneListener);
      this.dataSource.dataSourceEvents.removeOnRowChangeListener(this.addOnRowChangeListener);
      this.dataSource.dataSourceEvents.removeOnUpdateDoneListener(this.addOnUpdateDoneListener);
      this.dataSource.dataSourceEvents.removeOnCreateDoneListener(this.addOnCreateDoneListener);
      this.dataSource.dataSourceEvents.removeOnDeleteDoneListener(this.addOnDeleteDoneListener);
      this.dataSource.dataSourceEvents.removeOnDuplicateDoneListener(this.addOnDuplicateDoneListener)
      this.dataSource.dataSourceEvents.removeOnErrorListener(this.addOnErrorListener);
    }
  }

  doAddButtonGroupListeners() {
    if (GF.checkNotNull(this.props.headerButtons) && GF.checkNotNull(this.props.headerButtons.ref) &&
      GF.checkNotNull(this.props.headerButtons.ref.current)) {

      this.props.headerButtons.ref.current.tableEvents.addOnRefreshListener(this.onRefreshListener);
      this.props.headerButtons.ref.current.tableEvents.addOnFilterListener(this.onFilterListener);
      this.props.headerButtons.ref.current.tableEvents.addOnSimpleSearchListener(this.onSimpleSearchListener);
      this.props.headerButtons.ref.current.tableEvents.addOnSettingsListener(this.onSettingsListener);
      this.props.headerButtons.ref.current.tableEvents.addOnAddRecordListener(this.onAddRecordListener);
      this.props.headerButtons.ref.current.tableEvents.addOnEditRecordListener(this.onEditRecordListener);
      this.props.headerButtons.ref.current.tableEvents.addOnDeleteRecordListener(this.onDeleteRecordListener);
      this.props.headerButtons.ref.current.tableEvents.addOnImportListener(this.onImportListener);
      this.props.headerButtons.ref.current.tableEvents.addOnExportListener(this.onExportListener);
      this.props.headerButtons.ref.current.tableEvents.addOnDuplicateRecordsListener(this.onDuplicateRecordsListener);
    }
  }

  doRemoveButtonGroupListeners() {
    if (GF.checkNotNull(this.props.headerButtons) && GF.checkNotNull(this.props.headerButtons.ref) &&
      GF.checkNotNull(this.props.headerButtons.ref.current)) {

      this.props.headerButtons.ref.current.tableEvents.removeOnRefreshListener(this.onRefreshListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnFilterListener(this.onFilterListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnSimpleSearchListener(this.onSimpleSearchListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnSettingsListener(this.onSettingsListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnAddRecordListener(this.onAddRecordListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnEditRecordListener(this.onEditRecordListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnDeleteRecordListener(this.onDeleteRecordListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnImportListener(this.onImportListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnExportListener(this.onExportListener);
      this.props.headerButtons.ref.current.tableEvents.removeOnDuplicateRecordsListener(
        this.onDuplicateRecordsListener);
    }
  }

  initDatasourceListenerProperties() {
    this.addOnReadDoneListener = new Listener((records) => this.onReadDone(records));
    this.addOnRowChangeListener = new Listener((records) => this.onRowChangeDone(records));
    this.addOnUpdateDoneListener = new Listener((records) => this.onUpdateRowsDone(records));
    this.addOnCreateDoneListener = new Listener((records) => this.onCreateRowsDone(records));
    this.addOnDeleteDoneListener = new Listener((records) => this.onDeleteRowsDone(records));
    this.addOnErrorListener = new Listener((records) => this.onDatasourceError(records));
    this.addOnDuplicateDoneListener = new Listener((records) => this.onDuplicateDone(records));
  }

  initButtonGroupListenerProperties() {
    this.onRefreshListener = new Listener(() => this.doReadTable());
    this.onFilterListener = new Listener(() => this.doOpenFilter());
    this.onSimpleSearchListener = new Listener(() => this.doOpenSimpleSearch());
    this.onSettingsListener = new Listener(() => this.doOpenSettings());
    this.onAddRecordListener = new Listener(() => this.openDialog(CrudAction.CREATE));
    this.onEditRecordListener = new Listener(() => this.openDialog(CrudAction.UPDATE));
    this.onDeleteRecordListener = new Listener(() => this.openDialog(CrudAction.DELETE));
    this.onImportListener = new Listener(() => this.doImport());
    this.onExportListener = new Listener(() => this.doExport());
    this.onDuplicateRecordsListener = new Listener(() => this.openDialog(CrudAction.DUPLICATE));
  }

  initTable() {
    this.setState({rows: this.buildTableEntries(), totalRows: this.dataSource.getTotalRows()});
  }

  // onSimpleFilterChange(e) {
  //   let self = this;
  //   setTimeout(() => {
  //     this.simpleFilterTimerActive--;
  //     if (this.simpleFilterTimerActive === 0) {
  //       self.doReadTable();
  //     }
  //   }, 500);
  //   this.simpleFilterTimerActive++;
  // }

  buildTableEntries() {
    let records = this.dataSource.getRecords();
    this.hasRecordsInGrid = records.length > 0;
    let rows = [];
    for (let i = 0; i < records.length; i++) {
      let record = records[i];
      let row = {id: i + 1};

      for (let field in record) {
        let fieldName = field.split('#')[1];
        let fieldValue = record[field];
        let fieldType = this.getFieldTypeByName(field);
        // if the value is a link
        if (InputFieldGenerator.detectLink(fieldValue)) {
          fieldValue = InputFieldGenerator.extractLink(fieldValue);
        } else if (fieldType && fieldType.type === DataType.BOOLEAN) {
          fieldValue = this.convertStringToBoolean(fieldValue);
        }
        row[fieldName] = fieldValue;
      }
      rows.push(row);
    }
    return rows;
  }

  getKeyField(columns) {
    for (let fullFieldNameString in columns) {
      let column = columns[fullFieldNameString];

      if (column.type.isKey) {
        return {id: fullFieldNameString, column: column};
      }
    }
    return null;
  }

  getFieldsForQuery() {
    let fields = [];
    for (let fieldName in this.config.columns) {
      let column = this.config.columns[fieldName];
      if (column.type.type !== DataType.OBJECT && column.type.type !== DataType.DATA_EXT) {
        fields.push(fieldName);
      }
    }
    return fields;
  }

  getFieldType(id) {
    let column = this.config.columns[id];
    return column.type;
  }

  onAbortFilter() {
    this.doOpenFilter();
  }

  buildQuery() {
    let predicates = null;
    if (this.filterBuilderRef.current) {
      predicates = this.filterBuilderRef.current.getFilterPredicates();

      if (!this.filterBuilderRef.current.hasFilterChanged()) {
        this.buildEmptyIdPredicate(predicates);
      }
      predicates = this.cleanPredicates(predicates);
    }
    // handle sortierung
    let fieldList = this.getFieldsForQuery();
    let sortFields = [];
    for (let sortFieldFromGrid of this.state.sortModel) {
      for (let fullFieldName of fieldList) {
        let fielName = FieldName.create(fullFieldName);

        if (sortFieldFromGrid.field === fielName.getName()) {
          sortFields.push(new SortField(fullFieldName, sortFieldFromGrid.sort));
          break;
        }
      }
    }
    return new Query(fieldList, predicates, '', sortFields);
  }

  buildEmptyIdPredicate(predicates) {
    let fieldPredicate = predicates.predicates[0];
    if (GF.checkNotNull(fieldPredicate)) {
      fieldPredicate.fieldName.name = 'id';
      fieldPredicate.operator = Operator.neq;
      fieldPredicate.value1 = '';
      fieldPredicate.value2 = '';
    }
  }

  onDoFilter() {
    this.dataSource.read(this.buildQuery());
  }

  cleanPredicates(predicates) {
    return (new CleanPredicates()).iteratePredicates(predicates);
  }

  createFilterBuilder(columns, queryPredicates = null) {
    let keyColumn = this.getKeyField(columns);
    let fieldName = FieldName.create(keyColumn.id);
    fieldName['label'] = keyColumn.column.label;

    if (queryPredicates === null) {
      queryPredicates = new BooleanPredicate();
      queryPredicates.addPredicate(new FieldPredicate(fieldName));
    }
    return <>
      <FilterBuilder ref={this.filterBuilderRef} selectFields={columns} queryPredicates={queryPredicates} defaultFieldPredicate={{
        fieldNameValue: keyColumn.id,
        fieldLabelValue: keyColumn.column.label,
        fieldValue: '',
        operatorValue: Operator.eq,
        _key: ''
      }}/>
      <HorizontalLayout className='gap-4 justify-between'>
        <Button onClick={() => {
          this.doShowFilterListDialog();
        }}>
          Filterverwaltung
        </Button>
        <HorizontalLayout className='gap-4' widthFit>
          <Button color='' onClick={(e) => this.onAbortFilter(e)}>{T.label_cancel()}</Button>
          <Button onClick={(e) => this.onDoFilter(e)}>Filter anwenden</Button>
        </HorizontalLayout>
      </HorizontalLayout>
    </>;
  }

  applyFilter() {
    let currentRecords = this.filterManagerRef.current.dataSource.getCurrentRecords();
    if (currentRecords.length > 0) {
      let listName = currentRecords[0].listName;
      let filterQuery = this.filterManagerRef.current.getFilter(listName);
      if (filterQuery !== undefined && filterQuery !== null) {
        this.filterManagerDialogRef.current.closeDialog();
        this.filterBuilderRef.current.resetFilter(filterQuery.predicate);
        setTimeout(() => {
          this.onDoFilter();
        }, 1)
      }
    }
  }

  // doUstoreModuleServiceRequest(dto, campaignId, callBack) {
  //   dto.setProperties(CampaignService.createCampaignRedirectProperty(campaignId));
  //   CM.get().doJsonAjax(CM.get().getServiceUrl(UstoreModuleService.NAME), dto, (response) => {
  //     if (response.success) {
  //       callBack(response);
  //     } else {
  //       toast.error(response.message);
  //     }
  //   });
  // }

  doClearCache() {
    this.dataSource.doClearCache();
  }

  doReadTable(filterQuery = null) {
    this.doClearCache();
    this.dataSource.read(filterQuery);
  }

  doOpenFilter() {
    if (this.state.extendedFilter === null) {
      this.state.extendedFilter = this.createFilterBuilder(this.config.columns);
    } else {
      this.state.extendedFilter = null;
      this.dataSource.read(new Query(this.getFieldsForQuery()));
    }
    this.setState(this.state);
  }

  doOpenSimpleSearch() {
    const isActive = !this.state.simpleSearchIsActive;
    const fullKeys = Object.keys(this.config.columns);

    const updatedColumns = this.state.columns.map((column) => {
      const newColumn = { ...column };

      if (isActive) {
        const fullField = fullKeys.find((key) => key.endsWith('#' + column.field)) || column.field;
        const fieldType = this.config.columns[fullField] ? this.config.columns[fullField].type : null;
        newColumn.renderHeader = (params) => (
            <SimpleSearchHeaderCell
                label={params.colDef.headerName}
                field={fullField}
                fieldType={fieldType}
                value={this.state.simpleSearchValues ? this.state.simpleSearchValues[fullField] : null}
                fieldGenerator={this.simpleSearchFieldGenerator}
            />
        );
      } else {
        newColumn.renderHeader = (params) => (
            <div className="MuiDataGrid-columnHeaderTitle">
              {params.colDef.headerName}
            </div>
        );
      }

      return newColumn;
    });

    clearTimeout(this.simpleSearchDebounceTimer);

    this.setState({
      columns: updatedColumns,
      simpleSearchIsActive: isActive,
      simpleSearchValues: {},
    });

    if (!isActive) {
      this.applySimpleSearch({});
    }
  }

  renderDefaultHeader(params) {
    return (
        <div className="MuiDataGrid-columnHeaderTitle">
          {params.colDef.headerName}
        </div>
    );
  }

  handleSimpleSearchChange = (field, value) => {
    const updatedValues = { ...this.state.simpleSearchValues, [field]: value };
    this.setState({ simpleSearchValues: updatedValues });

    clearTimeout(this.simpleSearchDebounceTimer);
    this.simpleSearchDebounceTimer = setTimeout(() => {
      this.applySimpleSearch(updatedValues);
    }, 500);
  };

  applySimpleSearch(values) {
    const fieldPredicates = [];
    for (const field in values) {
      const value = values[field];
      if (value !== '' && value !== null && value !== undefined) {
        const column = this.config.columns[field];
        const fieldType = column ? column.type : null;
        let fieldPredicate;
        switch (fieldType ? fieldType.type : null) {
          case DataType.BOOLEAN:
          case DataType.ENUM:
            fieldPredicate = new FieldPredicate(FieldName.create(field), '', value, '', Operator.eq);
            break;
          case DataType.DATETIME: {
            // Die einfache Suche filtert immer auf den ganzen Tag (00:00:00 - 23:59:59),
            // unabhängig von einer allfälligen Uhrzeit im gepickten Wert, da der
            // DateTimePicker beim reinen Datumsklick trotzdem eine Uhrzeit anhängt.
            const datePart = String(value).split(' ')[0];
            const fieldName = FieldName.create(field);
            const fromPredicate = new FieldPredicate(fieldName, '', datePart + ' 00:00:00', '', Operator.geq);
            const toPredicate = new FieldPredicate(fieldName, '', datePart + ' 23:59:59', '', Operator.leq);
            fieldPredicate = new BooleanPredicate(Operator.and, [fromPredicate, toPredicate]);
            break;
          }
          default:
            fieldPredicate = new FieldPredicate(FieldName.create(field), '', '%' + value + '%', '', Operator.like);
        }
        fieldPredicates.push(fieldPredicate);
      }
    }

    const booleanPredicate = new BooleanPredicate(Operator.and, fieldPredicates);
    const query = this.dataSource.getLastQuery();
    if (query !== null) {
      query.setPredicate(booleanPredicate);
      this.dataSource.read(query);
    } else {
      const fallbackQuery = new Query(this.getFieldsForQuery());
      fallbackQuery.setPredicate(booleanPredicate);
      this.dataSource.read(fallbackQuery);
    }
  }

  doOpenSettings() {

  }

  openDialog(crudAction) {
    let currentSelectedRecords = this.dataSource.getCurrentRecIds();
    let dialogContent;
    let dialogTitle;
    if (crudAction === CrudAction.UPDATE || crudAction === CrudAction.DELETE) {
      if (!this.hasRecordsInGrid) {
        toast.warning('Keine Datensätze in der Tabelle vorhanden!');
        return;
      }
      if (!currentSelectedRecords.length) {
        toast.warning('Bitte wählen Sie zuerst einen Datensatz aus!');
      } else if (crudAction === CrudAction.UPDATE) {
        if (currentSelectedRecords.length !== 1) {
          toast.warning('Bitte wählen Sie nur ein Datensatz zum Editieren aus!');
          return;
        }
      }
    }

    switch (crudAction) {

      case CrudAction.CREATE:
        this.setState({
          dialogContent: this.generateRecordFields(crudAction),
          recordDialogOpen: true,
          dialogTitle: 'Neuer Datensatz erstellen',
          crudAction,
          validationErrorFields: new Set(),
          dialogKey: shortid()
        });
        break;

      case CrudAction.UPDATE:
        this.setState({
          dialogContent: this.generateRecordFields(crudAction),
          recordDialogOpen: true,
          dialogTitle: 'Datensatz editieren',
          crudAction,
          validationErrorFields: new Set(),
          dialogKey: shortid()
        });
        break;

      case CrudAction.DELETE:
        dialogContent = 'Möchten Sie [' + currentSelectedRecords.join(', ') + '] aus der Tabelle entfernen?';

        this.setState({
          confirmationDialogOpen: true,
          crudAction,
          dialogContent,
          dialogTitle: 'Datensätze entfernen',
          confirmationDialogConfirmAction: () => this.dataSource.deleteRows(
            new Records(this.dataSource.getCurrentRecords()))
        });
        break;

      case CrudAction.DUPLICATE:
        dialogTitle = 'Datensatz duplizieren';
        dialogContent = 'Möchten Sie den ausgewählten Datensatz [' + currentSelectedRecords + '] duplizieren?';
        this.setState({
          confirmationDialogOpen: true,
          dialogContent,
          dialogTitle,
          confirmationDialogConfirmAction: () => {this.dataSource.duplicateRows(
            new Records(this.dataSource.getCurrentRecords()));
            this.setState({confirmationDialogOpen: false});
          }
        });
        break;
    }
  }

  createRecordDialog() {
    return <DialogBase
      onCloseButtonClick={() => this.setState({recordDialogOpen: false, isLoading: false})}
      actions={<>
        <Button
          color=''
          onClick={() => this.setState({recordDialogOpen: false, isLoading: false})}
          autoFocus>
          {T.label_cancel()}
        </Button>
        <LoadingButton
          loading={this.state.isLoading}
          disabled={this.state.validationErrorFields.size > 0}
          variant='contained'
          onClick={() => {
            this.setState({isLoading: true});
            this.doSaveRecord();
          }}>
          {T.label_save()}
        </LoadingButton></>}
      key={this.state.dialogKey}
      open={this.state.recordDialogOpen}
      maxWidth={'xl'}
      title={this.state.dialogTitle}
      scroll='paper'
      fullWidth>
      <Grid container spacing={2}>
        {this.state.dialogContent}
      </Grid>
    </DialogBase>
  }

  createConfirmationDialog() {
    let {dialogTitle, confirmationDialogOpen, isLoading, dialogContent} = this.state;
    return <ConfirmationDialog
      key={shortid()}
      isOpen={confirmationDialogOpen}
      isLoading={isLoading}
      title={dialogTitle}
      onCancelClick={() => this.setState({confirmationDialogOpen: false})}
      onConfirmClick={this.state.confirmationDialogConfirmAction}
      confirmButtonColor='error'>
      {dialogContent}
    </ConfirmationDialog>;
  }

  createFilterManagerDialog() {
    // faha todo muss noch fertig gemacht werden
    let entityName = this.dataSource.getEntityDef().baseDef.name.toLowerCase().replace('\\', '/');
    return <DialogBase
      key={shortid()}
      ref={this.filterManagerDialogRef}
      title='Gespeicherte Filters'
      onCloseButtonClick={() => this.setState({filterManagerDialog: null})}>
      <FilterManager
        ref={this.filterManagerRef}
        entityName={entityName}
        entity={this}
        isMainTable={this.props.isMainTable}
        campaignId={this.props.campaignId}
        query={this.buildQuery()}
        onDoFilter={(e) => this.applyFilter(e)} parentRef={this.filterManagerDialogRef}/>
    </DialogBase>
  }

  doImport() {
    this.uploadTabId = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab
        tabTitle={(this.props.campaignId ? this.props.campaignId + ':' : '') + 'Import'}/>,
      <Upload ref={this.uploadRef}
              entity={this}
              dataSource={this.dataSource}
              campaignId={this.props.campaignId}/>);
  }

  doExport() {
    if (this.hasRecordsInGrid) {
      this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab
        tabTitle={(this.props.campaignId ? this.props.campaignId + ':' : '') + 'Export'}/>, <EntityExport
        dataSource={this.dataSource}/>);
    } else {
      toast.warning('Es hat keine Datensätze!');
    }
  }

  generateRecordFields(crudAction) {
    let fields = [];
    let record = this.dataSource.getCurrentRecords()[0];
    this.detailFieldList = [];

    for (let fieldName in this.config.columns) {
      let fieldValue = crudAction === CrudAction.UPDATE ? record[fieldName] : '';
      let column = this.config.columns[fieldName];
      if (column.type.type === DataType.ENUM) {
      }
      fields.push(<Grid size={3}>
        {this.initDetailField(fieldName, fieldValue, column.type, column.label, column.privilege.privilege)}
      </Grid>);
    }
    return fields;
  }

  getColumnConfig(fieldName) {
    let config = null;
    if (this.config.columns.hasOwnProperty(fieldName)) {
      config = this.config.columns[fieldName];
    }
    return config;
  }

  getFieldTypeByName(fieldName) {
    let type = null;
    let config = this.getColumnConfig(fieldName);
    if (config !== null) {
      type = config.type;
    }
    return type;
  }

  initConfig() {
    let muiColumns = [];
    this.config = {columns: {}};
    let entityDef = this.dataSource.getEntityDef();
    for (let fieldName in entityDef.fieldsDef) {
      let fieldDef = entityDef.fieldsDef[fieldName];
      let canView = Privilege.isPrivilegeAllowed(fieldDef.privilege.privilege, Privilege.ALLOW_VIEW);
      if (canView && fieldDef.type.type !== DataType.OBJECT) {
        let column = this.initColumnByType(fieldDef, fieldName);
        muiColumns.push(column);
        fieldDef.type.privilege = fieldDef.privilege;
        let fullFieldName = (new FieldName(fieldName, entityDef.baseDef.name)).getFullFieldName();
        this.config.columns[fullFieldName] = {
          label: fieldDef.description, type: fieldDef.type, privilege: fieldDef.privilege, simpleFieldValue: null
        };
      }
    }
    this.state.columns = muiColumns;
    this.numOfColumns = Object.keys(this.config.columns).length;
  }

  initColumnByType(fieldDef, fieldName) {
    let canEdit = Privilege.isPrivilegeAllowed(fieldDef.privilege.privilege, Privilege.ALLOW_EDIT);
    let fieldType = this.convertTypeToMuiDataGridsType(fieldDef.type);
    let field = {
      field: fieldName, headerName: fieldDef.description, editable: canEdit, type: fieldType
    };
    if (fieldType === 'link') {
      field.renderCell = (params) => {
        let href = '';
        let text = '';
        if (params.value) {
          href = params.value.href;
          text = params.value.text;
        }
        return <a
          className='text-cn-color-primary'
          rel='noreferrer'
          href={href}
          target="_blank">
          {text}
        </a>;
      };
    } else if (fieldType === 'date') {
      field.valueGetter = (params) => params || '';
      field.valueFormatter = (params) => params || '';
      // Render the DateTimePicker in the cell
      field.renderEditCell = (params) => (<InputDateTimePicker size='small' defaultValue={params.value}/>);
    } else if (fieldType === 'singleSelect') {
      let options = [];
      for (const key in fieldDef.type.valueMap) {
        let option = fieldDef.type.valueMap[key];
        option = option instanceof Array ? option.join(', ') : option;
        options.push({value: parseInt(key), label: option});
      }
      field.valueOptions = options;
    } else if (fieldType === DataType.DATA_EXT) {
      delete field['type'];
      let dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
      field.renderCell = (params) => (<InputDownload defaultValue={params.value} dtoProperties={dtoProperties}/>);
      field.renderEditCell = (params) => (<InputUpload size='small' dtoProperties={dtoProperties} defaultValue={params.value}/>);
    }
    return field;
  }

  initField(fieldType, id, fieldValue, fieldLabel = null, fieldRef = null) {
    let dtoProperties = null;
    if (this.props.campaignId) {
      dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
    }
    return this.tableFieldGenerator.initField(fieldType, id, fieldValue, fieldLabel, fieldRef, dtoProperties);
  }

  initDetailField(fieldName, fieldValue, fieldType, fieldLabel, privilege) {
    let tempRef = createRef();
    let dtoProperties = null;
    if (this.props.campaignId) {
      dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
    }
    let field = this.editFieldGenerator.initField(fieldType, fieldName, fieldValue, fieldLabel, tempRef, dtoProperties,
      privilege);
    this.detailFieldList.push(tempRef);
    return field;
  }

  onPageChanged = (actualPage, _query) => {
    this.setState({dataGridsActualPage: actualPage});
    let pageSize = this.state.dataGridsPageSize;
    let query = _query;
    if (!_query) {
      query = this.dataSource.getLastQuery();
    }
    let start = actualPage * pageSize - pageSize;
    let end = actualPage * pageSize - 1;
    query.setStartRow(start);
    query.setEndRow(end);
    this.dataSource.read(query);
  }

  onPageSizeChanged = (e, id, pageSize) => {
    this.setState({dataGridsPageSize: pageSize, dataGridsActualPage: 1});
    let query = this.dataSource.getLastQuery();
    query.setStartRow(0);
    query.setEndRow(pageSize - 1);
    this.dataSource.read(query);
  }

  doSaveRecord() {
    let record = {};
    // hole Daten
    for (let index in this.detailFieldList) {
      let fieldRef = this.detailFieldList[index];
      let id = fieldRef.current.getId();
      let fieldType = this.getFieldType(id);
      if (this.state.crudAction !== CrudAction.CREATE || !fieldType.type.isKey) {
        record[id] = fieldRef.current.getValue();
      }
    }

    this.prepareUploadFields(record, () => {
      this.prepareFieldValuesForServer(record);
      if (this.state.crudAction === CrudAction.UPDATE) {
        this.dataSource.updateRows(new Records([record]));
      } else {
        this.dataSource.createRows(new Records([record]));
      }
      this.setStatusOnButtonGroup(BaseComponent.STATUS_ENABLED);
    });
  }

  loopThroughDataExtFields(record, doSomething) {
    for (let id in record) {
      let fieldValue = record[id];
      let fieldType = this.getFieldType(id);
      switch (fieldType.type) {
        case DataType.DATA_EXT:
          doSomething(id, fieldValue);
          break;
      }
    }
  }

  prepareUploadFields(record, prepareDoneCallback) {
    let collectedFiles = [];
    this.loopThroughDataExtFields(record, (id, fieldValue) => {
      if (typeof fieldValue === 'object') {
        collectedFiles.push(fieldValue);
      }
    });
    if (collectedFiles.length > 0) {
      let dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
      let resource = new Resource(dtoProperties);

      resource.doManageResources(collectedFiles, () => {
        prepareDoneCallback();
      })
    } else {
      prepareDoneCallback();
    }
  }

  prepareFieldValuesForServer(record) {
    this.loopThroughDataExtFields(record, (id, fieldValue) => {
      record[id] = fieldValue.getResourceIdAndName();
    });
  }

  onDatasourceError(response) {
    let message;
    if (GF.checkNotNull(response.message)) {
      message = response.message;
    } else {
      message = response;
    }
    toast.error(message);
    this.setState({isLoading: false});
  }

  onCreateRowsDone() {
    this.dataSource.read();
    this.setState({recordDialogOpen: false, isLoading: false});
  }

  onUpdateRowsDone(response) {
    this.onReadDone(response);
    this.setState({recordDialogOpen: false, isLoading: false});
  }

  onDeleteRowsDone() {
    this.setState({confirmationDialogOpen: false, isLoading: false});
    this.onReadDone();
  }

  onRowChangeDone(event) {
    this.setState(this.state);
  }

  onRowSelectionModelChange = (newSelection) => {
    this.dataSource.setCurrentRecIds(newSelection);
  }

  onReadDone() {
    this.initTable();
  }

  onDataGridRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    this.setState((prevState) => {
      prevState.rows.map((row) => (row.id === newRow.id ? updatedRow : row))
    });
    return updatedRow;
  }

  handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  setStatusOnButtonGroup(status) {
    if (this.props.headerButtons !== undefined && this.props.headerButtons !== null) {
      BaseComponent.loopThrowChildren(this.props.headerButtons, (node) => {
        if (node !== undefined && node !== null && node.ref !== undefined && node.ref !== null && node.ref.current !==
          undefined && node.ref.current !== null) {

          node.ref.current._status = status;
        }
      });
    }
  }

  initHeaderButtons() {
    let headerButtonsFromProps;
    if (this.props.headerButtons) {
      headerButtonsFromProps = this.props.headerButtons;
    }
    let functionElementsFromProps;
    if (this.props.functionElements) {
      functionElementsFromProps = this.props.functionElements;
    }
    if (this.props.headerButtons) {
      return <HorizontalLayout className='justify-between'>
        {headerButtonsFromProps}
        {functionElementsFromProps}
      </HorizontalLayout>;
    }
  }

  onDuplicateDone(records) {
    this.dataSource.read();
    toast.success('Datensatz wurde erfolgreich kopiert.');
  }

  convertTypeToMuiDataGridsType(type) {
    switch (type.type) {
      case DataType.DATA_EXT:
        return DataType.DATA_EXT;
      case DataType.BOOLEAN:
        return 'boolean'
      case DataType.INTEGER:
        return 'number'
      case DataType.DATETIME:
        return 'date'
      case DataType.STRING:
        if (type.isLink) {
          return 'link';
        }
        return 'string';
      case DataType.ENUM:
        return 'singleSelect'
      default:
        return 'string';
    }
  }

  /**
   * in der liste wird geschaut ob bool value existiert und gibt false oder true zurück
   * @param value
   * @returns {boolean}
   */
  convertStringToBoolean(value) {
    return value === "1" || value === "true" || value === "ja" || value === "JA" || value === 1 || value === true;
  }

  doLoadFilterListDialog = (callback) => {
    let entityName = this.getEntityName();
    let sysLastValueId = FilterListDialog.buildSysLastValueId(this.props.campaignId, entityName);

    FilterListDialog.loadFilterList(sysLastValueId, (filterListRows, filterListData) => {
      this.setState({filterListRows: filterListRows, filterListData: filterListData});
      if (callback) {
        callback();
      }
    });
  }

  doShowFilterListDialog(event) {
    this.doLoadFilterListDialog(() => {
      this.setState({isFilterListDialogOpen: true});
    });
  }

  createFilterListDialog = () => {
    let entityName = this.getEntityName();

    return <FilterListDialog parent={this}
                             open={this.state.isFilterListDialogOpen}
                             rows={this.state.filterListRows}
                             data={this.state.filterListData}
                             canClose
                             canEdit
                             displayMode={'outline'}
                             query={this.buildQuery()}
                             campaignId={this.props.campaignId}
                             entityName={entityName}
                             onClose={() => {
                               this.setState({isFilterListDialogOpen: false});
                             }} onDone={(dataRecord) => {
      this.dataSource.read(dataRecord.query);
    }}/>;
  }

  createDialogs() {
    let dialogs = [];
    if (this.dataSource) {
      dialogs = [this.createConfirmationDialog(),
        this.createRecordDialog(),
        // TODO: peto, das muss noch aufgeräumt werden
        //this.createFilterManagerDialog()
        this.createFilterListDialog()
      ];
    }
    return dialogs;
  }

  getEntityName() {
    let entityDef = this.dataSource.getEntityDef();
    let entityName = '';
    if (entityDef && entityDef.hasOwnProperty('baseDef')) {
      let baseDef = entityDef.baseDef;
      if (baseDef && baseDef.hasOwnProperty('name')) {
        entityName = baseDef.name.replace(/\\/g, '/');
      }
    }
    return entityName;
  }

  handleRowDoubleClick = (params, event) => {
    event.preventDefault();
    event.stopPropagation();
    this.openDialog(CrudAction.UPDATE);
  };

  handleSortModelChange = (newSortModel) => {
    this.state.sortModel = newSortModel;
    this.onPageChanged(this.state.dataGridsActualPage, this.buildQuery());
  };

  handleVisibilityChange = (newModel) => {
    this.state.visibilityModel = newModel;
    let valueid = this.buildSysLastValueId(this.props.campaignId, this.props.dataSource.entityDef.baseDef.name);
    this.updateVisibilityChange(valueid, newModel, (success) => {
      if (success) {
        this.forceUpdate();
      }
    });
  };

  updateVisibilityChange(sysLastValueId, value, callBack) {
    SystemService.doRequest(new SysLastValueWrite(sysLastValueId, value), (response) => {
      callBack(response.success);
    }, 'Es konnten keine Daten geliefert werden!');
  }

  loadVisibilityChange() {
    SystemService.doRequest(new SysLastValueRead(this.buildSysLastValueId(this.props.campaignId, this.props.dataSource.entityDef.baseDef.name)), (response) => {
      if(response.data.data.length > 0){
        this.state.visibilityModel = JSON.parse(response.data.data[0].value);
        this.doReadTable();
      }
    });
  }

  buildSysLastValueId(campaignId, entityName) {
    if(campaignId === undefined){
      let sysLastValueId = 'cner21/campaign/visibility/' + entityName;
      sysLastValueId = sysLastValueId.replace(/\\/g, '/');
      return sysLastValueId;
    }else{
      let sysLastValueId = 'cner21/campaign/visibility/' + campaignId + '/' + entityName;
      sysLastValueId = sysLastValueId.replace(/\\/g, '/');
      return sysLastValueId;
    }
  }

  getHeaderHeight() {
    const density = this.state.density || 'standard';

    const heights = {
      compact:     { normal: 36, search: 96 },
      standard:    { normal: 44, search: 84 },
      comfortable: { normal: 52, search: 92 },
    };

    return this.state.simpleSearchIsActive
        ? heights[density].search
        : heights[density].normal;
  }

  render() {
    let headerButtons = this.initHeaderButtons();
    let filteredRows = this.state.rows.filter((row) => row !== undefined && row !== null);
    return (<>
      <VerticalLayout ref={this.entityContainerRef} className='CNINFO-Entity gap-y-2'>
        {headerButtons}
        {this.state.extendedFilter}
        <DataGrid
          onRowClick={(row) => this.dataSource.setCurrentRecIds(row.id)}
          onRowSelectionModelChange={this.onRowSelectionModelChange}
          onProcessRowUpdateError={(error) => console.error(error)}
          onSortModelChange={this.handleSortModelChange}
          sortModel={this.state.sortModel}
          onRowDoubleClick={this.handleRowDoubleClick}
          disableRowSelectionOnClick

          editMode="row"
          onRowEditStop={this.handleRowEditStop}
          processRowUpdate={this.onDataGridRowUpdate}

          columnVisibilityModel={this.state.visibilityModel}
          onColumnVisibilityModelChange={this.handleVisibilityChange}

          ref={this.tableRef}
          columns={this.state.columns}
          rows={filteredRows}
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          density={this.state.density || 'standard'}
          onDensityChange={(newDensity) => this.setState({ density: newDensity })}
          slots={{toolbar: GridToolbar}}
          slotProps={{toolbar: {printOptions: {disableToolbarButton: true}, csvOptions: {disableToolbarButton: true}}}}
          columnHeaderHeight={this.getHeaderHeight()}
          rowHeight={44}
          showColumnVerticalBorder
          showCellVerticalBorder
          hideFooterPagination
          checkboxSelection
          disableColumnFilter
          isCellEditable={(params) => false}

          disableColumnSorting={this.state.simpleSearchIsActive}
          disableColumnMenu={this.state.simpleSearchIsActive}

          sx={{
            // Der Spaltentrenner im Header war unsichtbar, weil MUI ihm standardmässig die
            // (kaum sichtbare) Border-Farbe des Themes gibt, die praktisch gleich dem
            // Hintergrund ist. Farbe an den h2-Titeltext angleichen (--color-white passt
            // sich wie bei h2 dem Dark-/Light-Mode an).
            // Das eigentliche Trenner-Icon von MUI ist ein fixes 24px-SVG, das bei höheren
            // Spaltenköpfen (z.B. in der einfachen Suche) nicht mitwächst und daher kürzer
            // wirkt als die Headerzeile. Es wird deshalb ausgeblendet und durch eine reine
            // CSS-Linie ersetzt, die immer die volle Höhe des Spaltenkopfs einnimmt.
            // MUI blendet den Separator standardmässig aus (opacity: 0), sobald die Spalte
            // eine linke/rechte Border hat (bei uns immer, wegen showColumnVerticalBorder)
            // und zeigt ihn nur beim exakten Hover der schmalen 10px-Resize-Zone wieder ein
            // (".columnSeparator--resizable:hover"). Dadurch blitzte die Linie beim
            // Drüberfahren nur kurz auf. "!important" erzwingt eine durchgehend sichtbare
            // Linie, unabhängig von Hover-/Fokus-/Border-Zustand.
            '& .MuiDataGrid-columnSeparator': {
              color: 'var(--color-white)',
              opacity: '1 !important',
            },
            '& .MuiDataGrid-columnSeparator .MuiDataGrid-iconSeparator': {
              display: 'none',
            },
            '& .MuiDataGrid-columnSeparator::after': {
              content: '""',
              display: 'block',
              width: '5px',
              height: '100%',
              backgroundColor: 'var(--color-white)',
            },
            ...(this.state.simpleSearchIsActive ? {
              // Der Titel-Container im Spaltenkopf wächst standardmässig nicht mit der
              // Spaltenbreite (er ist nur so breit wie sein Inhalt). Damit die Suchfelder
              // (Dropdown, DatePicker, Text, ...) beim Verbreitern der Spalte mitwachsen,
              // wird der Container hier auf volle Breite gezwungen.
              '& .MuiDataGrid-columnHeaderTitleContainerContent': {
                flex: 1,
                minWidth: 0,
                width: '100%'
              }
            } : {})
          }}
        />
        <Pager
          actualPage={this.state.dataGridsActualPage}
          pageSize={this.state.dataGridsPageSize}
          totalRows={this.state.totalRows}
          onPageSizeChanged={this.onPageSizeChanged}
          onPageChanged={(actualPage) => this.onPageChanged(actualPage)}/>
      </VerticalLayout>
      {this.createDialogs()}
    </>);
  }
}

Entity.propTypes = {
  parent: PropTypes.object,
  tabContainer: PropTypes.object,
  dataSource: PropTypes.object,
  config: PropTypes.object,
  campaignId: PropTypes.any,
  headerButtons: PropTypes.node,
  functionElements: PropTypes.node,
  autoload: PropTypes.bool,
  tableFieldGenerator: PropTypes.object,
  editFieldGenerator: PropTypes.object,
  readonly: PropTypes.bool,
  isMainTable: PropTypes.string
}
export default Entity
